import PropTypes from 'prop-types';
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

import './LinearProgressBar.css';
import { Chip } from '@mui/material';
import { useSelector } from 'react-redux';
import useIncrement from '../../hook/useIncrement';
import color from '../../config/color';
import { selectTranslation } from '../../features/langSlice';

function LinearProgressBar({ percentage = 20, name, label }) {
  const progress = useIncrement(percentage);
  const labelTranslated = useSelector(selectTranslation(label));

  const getLabelColor = () => {
    switch (label) {
      case 'dérouillard':
        return `${color.secondaryColor}4D`;
      case 'confirmé':
        return `${color.secondaryColor}99`;
      case 'expérimenté':
        return `${color.secondaryColor}FF`;

      default:
        return `${color.secondaryColor}99`;
    }
  };
  return (
    <div className="container-bar">
      <div className="description-bar">
        <div className="name-bar">{name}</div>
        {label && (
          <Chip
            label={labelTranslated}
            variant="outlined"
            size="small"
            sx={{
              fontSize: '10px',
              fontWeight: '200',
              color: color.blackLightColor,
              height: '20px',
              padding: '0 6px',
              border: '1.5px solid transparent',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              borderColor: getLabelColor(label),
              borderRadius: '16px',
              backgroundColor: 'white',
              boxShadow: '0 0 0 1px transparent',
            }}
          /> // <div
        //   className="progress-label-bar"
        //   style={{ backgroundColor: getLabelColor(label) }}
        // >
        //   {label}
        // </div>
        )}
      </div>

      <LinearProgress
        sx={{ backgroundColor: color.grey300Color }}
        variant="determinate"
        value={progress}
        color="secondary"
      />
    </div>

  );
}
LinearProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOf(['dérouillard', 'confirmé', 'expérimenté']).isRequired,
};
export default LinearProgressBar;
